var map = {
	"./2015-10-16 19.04.07.jpg": 1763,
	"./2015-10-16 19.07.43.jpg": 9638,
	"./2015-10-16 19.10.26.jpg": 4633,
	"./2015-10-16 19.18.41.jpg": 5792,
	"./2015-10-16 19.25.22.jpg": 2833,
	"./2017Dailyok.jpg": 7655,
	"./2017k12.jpg": 6880,
	"./2017k12_1.jpg": 4160,
	"./2017k12_3.jpg": 5826,
	"./2018PresidentCup1.jpg": 4326,
	"./2018PresidentCup2.jpg": 1025,
	"./2019 RA Flyer FINAL_001.png": 4169,
	"./2019 RA Flyer FINAL_002.png": 162,
	"./23066743526_85d4333b22_o.jpg": 5185,
	"./23111717752_0ab35c9f40_o.jpg": 8143,
	"./3mt1.png": 8975,
	"./Duy_award.jpg": 6508,
	"./IMG_1060.jpg": 4143,
	"./IMG_1286.jpg": 1721,
	"./IMG_1342.jpg": 7812,
	"./IMG_1438.jpg": 6632,
	"./NLD2015_1.jpg": 7574,
	"./NLD2015_2.jpg": 5345,
	"./NLD2015_3.jpg": 6820,
	"./NLD2016_1.jpg": 3301,
	"./NLD2016_2.jpg": 7050,
	"./NLD2016_3.jpg": 887,
	"./NLD2018 (1).jpg": 4217,
	"./NLD2018 (2).jpg": 2416,
	"./NLD2018 (3).jpg": 4227,
	"./NLD2018 (4).jpg": 8642,
	"./NLD2018 (5).jpg": 2269,
	"./NLD2018 (7).jpg": 103,
	"./Nov302016_1.jpg": 8843,
	"./Nov302016_2.jpg": 3676,
	"./Nov302016_3.jpg": 8025,
	"./Nov302016_4.jpg": 2282,
	"./Nov302016_5.jpg": 8087,
	"./OSUNLD2014_1.jpg": 228,
	"./OSUNLD2014_2.jpg": 6291,
	"./TrungApp.jpg": 3657,
	"./asccdemos.png": 6058,
	"./asccdemos1.png": 505,
	"./bookworms.png": 2113,
	"./bookworms1.png": 4671,
	"./case2016_1.jpg": 5765,
	"./case2016_2.jpg": 9514,
	"./case2016_3.jpg": 1703,
	"./case2016_4.jpg": 5708,
	"./case2016_5.jpg": 409,
	"./default.png": 8939,
	"./endeavor1.png": 2143,
	"./endeavor2.png": 6884,
	"./endeavor3.png": 4365,
	"./ha_kids.jpg": 7651,
	"./image.png": 8863,
	"./juniorday.png": 443,
	"./juniorday1.png": 9066,
	"./juniorday2.png": 9233,
	"./juniorday3.png": 1368,
	"./sangre1.jpg": 9247,
	"./sangre2.jpg": 1248,
	"./stemday.png": 1783,
	"./stemday1.png": 9198,
	"./stemday2.png": 1621,
	"./zhidong_3mt.png": 9764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3065;